import React, { useState, useCallback, useEffect } from 'react';
import { FiX, FiTruck } from 'react-icons/fi';
import { Modal } from '../../ui/Modal';
import { QuoteForm } from './QuoteForm';
import { SuccessMessage } from './SuccessMessage';

const INITIAL_STATE = {
  cargoType: '',
  shipmentType: '',
  from: '',
  to: '',
  weightKg: '',
  volumeM3: '',
  company: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  message: '',
};

/**
 * Quote modal component
 *
 * @param {Object} props
 * @param {boolean} props.open - Modal open state
 * @param {Function} props.onClose - Close handler
 */
const QuoteModal = ({ open, onClose }) => {
  const [form, setForm] = useState(INITIAL_STATE);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  // Reset state when modal closes
  useEffect(() => {
    if (!open) {
      setSent(false);
      setForm(INITIAL_STATE);
    }
  }, [open]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { sendQuoteRequest } = await import('../../../services/api');
      await sendQuoteRequest(form);
      setSent(true);
      setForm(INITIAL_STATE);
    } catch (err) {
      console.error('Form submission error:', err);
      alert(err.message || 'Teklif gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
    } finally {
      setSending(false);
    }
  }, [form]);

  return (
    <Modal open={open} onClose={onClose} size="lg">
      {/* Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
          <FiTruck className="text-primary" aria-hidden="true" />
          Talep Formu
        </h2>
        <button
          type="button"
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={onClose}
          aria-label="Formu kapat"
        >
          <FiX size={24} aria-hidden="true" />
        </button>
      </div>

      {/* Body */}
      {sent ? (
        <SuccessMessage onClose={onClose} />
      ) : (
        <QuoteForm
          form={form}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isSubmitting={sending}
        />
      )}
    </Modal>
  );
};

export default QuoteModal;
